import React, { SVGProps } from 'react';
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

import { IconProps } from 'components/assets/Icons/Icons';

/* eslint-disable max-len */
const WarningSVG = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 8.5C15.5 12.366 12.366 15.5 8.5 15.5C4.63401 15.5 1.5 12.366 1.5 8.5C1.5 4.63401 4.63401 1.5 8.5 1.5C12.366 1.5 15.5 4.63401 15.5 8.5ZM16.5 8.5C16.5 12.9183 12.9183 16.5 8.5 16.5C4.08172 16.5 0.5 12.9183 0.5 8.5C0.5 4.08172 4.08172 0.5 8.5 0.5C12.9183 0.5 16.5 4.08172 16.5 8.5ZM9.20857 9.90531L9.5 4H7.52286L7.81429 9.90531H9.20857ZM8.50571 12.9999C8.8181 12.9999 9.0619 12.9082 9.23714 12.7249C9.41238 12.5415 9.5 12.2907 9.5 11.9724C9.5 11.6419 9.41333 11.3881 9.24 11.2108C9.06667 11.0335 8.82191 10.9448 8.50571 10.9448C8.1781 10.9448 7.92857 11.0315 7.75714 11.2047C7.58571 11.378 7.5 11.6339 7.5 11.9724C7.5 12.2988 7.58762 12.5516 7.76286 12.7309C7.9381 12.9102 8.18571 12.9999 8.50571 12.9999Z"
            fill="#49565D"
        />
    </svg>
);

export const WarningIcon = (props: IconProps) => <Icon component={WarningSVG} {...props} />;
